<template>
    <div>
        <highcharts :options="chartOptions"></highcharts>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';

@Component({
    name: 'd-langsBar',
    components: {
        highcharts: Chart
    }
})
export default class DSocialLangsBar extends Vue {
    @Prop({
        required: false,
        default: null
    })
    section;

    @Prop({
        required: false,
        default: null
    })
    datas;

    @Prop({
        required: false,
        default: []
    })
    unrelevants;

    chartOptions = {};

    created() {
        this.$watch('datas', () => {
            this.updateOptions();
        });
    }

    mounted() {
        this.updateOptions();
    }

    updateOptions() {
        const colors = ['#f8cbad', '#bfbfbf', '#3b7cb7', '#e37979', '#bdd7ee'];
        const series = [];
        const categories = [];

        const total = [];
        const kzDatas = [];
        const ruDatas = [];
        const enDatas = [];

        this.datas.forEach((item) => {
            if (item.datas.data.length > 0) {
                categories.push(item.theme.name);

                let tot = 0;
                let kz = 0;
                let ru = 0;
                let en = 0;
                item.datas.data.forEach((post) => {
                    if (this.unrelevants.indexOf(post.id) === -1) {
                        switch (post.lang) {
                            case 'kz':
                                kz++;
                                break;
                            case 'ru':
                                ru++;
                                break;
                            default:
                                en++;
                                break;
                        }
                        tot++;
                    }
                });
                total.push(tot);
                kzDatas.push(kz);
                ruDatas.push(ru);
                enDatas.push(en);
            }
        });
        // series.push({name: 'Всего', data: total})
        series.push({ name: 'Казахский', data: kzDatas });
        series.push({ name: 'Русский', data: ruDatas });
        series.push({ name: 'Другие', data: enDatas });

        this.chartOptions = {
            colors,
            chart: {
                type: 'bar'
            },
            title: {
                text: (this.section.section !== null ? this.section.section.name : ''),
                style: {
                    color: '#5e5e5e',
                    fontSize: '1rem'
                }
            },
            xAxis: {
                categories: categories,
                labels: {
                    style: {
                        fontSize: '1rem',
                        color: '#5e5e5e'
                    }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                }
            },
            legend: {
                itemStyle: {
                    color: '#5e5e5e',
                    fontSize: '.9rem',
                    fontWeight: 'normal'
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        backgroundColor: '#fff',
                        borderColor: '#f2f2f2',
                        borderWidth: '1px',
                        formatter() {
                            return (this.y > 0 ? '<span style="color: ' + this.point.color + '">' + this.y + '</span>' : '');
                        },
                        style: {
                            fontSize: '.8rem',
                            fontWeight: 'bold',
                            color: '#fff',
                            textOutline: '0'
                        }
                    }
                },
                series: {
                    stacking: 'normal',
                    pointWidth: 20
                }
            },
            series: series,
            credits: {
                enabled: false
            }
        };
    }
}
</script>